import * as React from 'react';
import Accordion from '../../../../components/Accordion/Accordion';
import { useTranslation } from 'react-i18next';
import HydraulicDataVerticalDrop from './HydraulicData/HydraulicDataVerticalDrop';
import HydraulicDataSteppedWeir from './HydraulicData/HydraulicDataSteppedWeir';
import HydraulicDataSlopedWeir from './HydraulicData/HydraulicDataSlopedWeir';
import ChannelGeometryVerticalDrop from './ChannelGeometry/ChannelGeometryVerticalDrop';
import ChannelGeometrySteppedWeir from './ChannelGeometry/ChannelGeometrySteppedWeir';
import WeirGeometryVerticalDrop from './WeirGeometry/WeirGeometryVerticalDrop';
import WeirGeometrySteppedWeir from './WeirGeometry/WeirGeometrySteppedWeir';
import WeirGeometrySlopedWeir from './WeirGeometry/WeirGeometrySlopedWeir';
import WingsGeometryVerticalDrop from './WingsGeometry/WingsGeometryVerticalDrop';
import WingsGeometrySteppedWeir from './WingsGeometry/WingsGeometrySteppedWeir';
import WingsGeometrySlopedWeir from './WingsGeometry/WingsGeometrySlopedWeir';
import StillingBasinVerticalDrop from './StillingBasin/StillingBasinVerticalDrop';
import StillingBasinSteppedWeirSlopedWeir from './StillingBasin/StillingBasinSteppedWeirSlopedWeir';
import SoilDataVerticalDrop from './SoilData/SoilDataVerticalDrop';
import './InputForm.scss';
import { useAppSelector } from '../../../../reduxService/hooks';
import { selectProjectInfo } from '../../../store/projectInfo/projectInfoSlice';
import { EProjectType } from '../../../enum/project';
import ChannelGeometrySlopedWeir from './ChannelGeometry/ChannelGeometrySlopedWeir';

interface IInputForm {
    children?: any;
}
const InputForm = (props: IInputForm) => {
    const { t } = useTranslation();
    const projectInfo = useAppSelector(selectProjectInfo);
    let hydraulicData, channelGeometry, weirGeometry, wingsGeometry, stillingBasin, soilData;
    let type = projectInfo.data!.type;

    switch (type) {
        case EProjectType.Macra2 | EProjectType.VerticalDrop:
            hydraulicData = <HydraulicDataVerticalDrop />;
            channelGeometry = <ChannelGeometryVerticalDrop />;
            weirGeometry = <WeirGeometryVerticalDrop />;
            wingsGeometry = <WingsGeometryVerticalDrop />;
            stillingBasin = <StillingBasinVerticalDrop />;
            soilData = <SoilDataVerticalDrop />;
            break;
        case EProjectType.Macra2 | EProjectType.SteppedWeir:
            hydraulicData = <HydraulicDataSteppedWeir />;
            weirGeometry = <WeirGeometrySteppedWeir />;
            channelGeometry = <ChannelGeometrySteppedWeir />;
            wingsGeometry = <WingsGeometrySteppedWeir />;
            stillingBasin = <StillingBasinSteppedWeirSlopedWeir />;
            break;
        case EProjectType.Macra2 | EProjectType.SlopedWeir:
            hydraulicData = <HydraulicDataSlopedWeir />;
            weirGeometry = <WeirGeometrySlopedWeir />;
            channelGeometry = <ChannelGeometrySlopedWeir />;
            wingsGeometry = <WingsGeometrySlopedWeir />;
            stillingBasin = <StillingBasinSteppedWeirSlopedWeir />;
            break;
        default:
            break;
    }
    return (
        <div className='InputForm'>
            <Accordion title={t('input_form_accordion_hydraulic_data')}>{hydraulicData}</Accordion>
            <Accordion title={t('input_form_accordion_channel_geometry')}>{channelGeometry}</Accordion>
            <Accordion title={t('input_form_accordion_weir_geometry')}>{weirGeometry}</Accordion>
            <Accordion title={t('input_form_accordion_wings_geometry')}>{wingsGeometry}</Accordion>
            <Accordion title={t('input_form_accordion_stilling_basin')}>{stillingBasin}</Accordion>
            {type === (EProjectType.Macra2 | EProjectType.VerticalDrop) && <Accordion title={t('input_form_accordion_soil_data')}>{soilData}</Accordion>}
            {!!props.children ? props.children : <></>}
        </div>
    );
};

export default InputForm;
